import styled from 'styled-components'

import { helpers } from 'styles'

export const Table = styled.table`
	font-size: 14px;
	margin-bottom: 10px;
	border-spacing: 0;
	width: 100%;
	border-width: 1px 1px 0 1px;
	border-style: solid;
	border-color: ${helpers.color.border};
	border-radius: 4px;
	table-layout: auto;

	td {
		/* Some text blocks include code tags and they should usually be allowed to break in tables to avoid overflow */
		> code:not(:only-child) {
			overflow-wrap: anywhere;
		}
	}

	th {
		font-weight: 500;
		font-family: ${helpers.font.family.header};
		font-size: ${helpers.font.size.base};
		text-align: left;
		color: ${helpers.color.textHeader};
		background-color: ${helpers.color.tableHeader};

		&:first-child {
			border-top-left-radius: 4px;
		}

		&:last-child {
			border-top-right-radius: 4px;
		}
	}

	td,
	th {
		border-width: 0 1px 1px 0;
		border-style: solid;
		border-color: ${helpers.color.border};
		padding: 6px 8px;

		&:last-child {
			border-right: none;
		}
	}

	tr:last-child {
		td:first-child {
			border-bottom-left-radius: 4px;
		}

		td:last-child {
			border-bottom-right-radius: 4px;
		}
	}
`
